export default "__VITE_ASSET__CvcfdWUM__"